<!--used to display the email archive details of saved items
In (ui) discovery tool-> overview-> select any active project-> go to saved items-> email archives-> open any mail
-->
<template>
  <v-container class="boxContainer archive-detail">
    <v-row v-if="archiveDetails" class="mb-2 mt-2">
      <v-icon @click="goToSavedItems()" class="pointer" data-test-id="go-back-to-saved-items">arrow_back_ios</v-icon>
      <v-col sm="6" class="pa-0">
        <label class="org_page-head">{{ archiveDetails.subject }}</label>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col sm="6">
        <v-skeleton-loader type="article" :loading="true"></v-skeleton-loader>
      </v-col>
      <v-col sm="6">
        <v-skeleton-loader
          type="actions"
          :loading="true"
          tile
        ></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col sm="6" v-if="archiveDetails">
        <v-row class="ml-3 mb-2" v-if="archiveDetails.from" no-gutters>
          <v-col>
            <span>From&nbsp;:&nbsp;</span>
            <span class="description-item">{{ archiveDetails.from }}</span>
          </v-col>
        </v-row>
        <v-row class="ml-3 mb-2" no-gutters v-if="archiveDetails.tos">
          <v-col>
            <span>To&nbsp;:&nbsp;</span>
            <span class="description-item">{{
              getEmailList(archiveDetails.tos)
            }}</span>
          </v-col>
        </v-row>

        <v-row class="ml-3 mb-2" v-if="archiveDetails.ccs" no-gutters>
          <v-col>
            <span>Cc&nbsp;:&nbsp;</span>
            <span class="description-item">{{
              getEmailList(archiveDetails.ccs)
            }}</span>
          </v-col>
        </v-row>

        <v-row class="ml-3 mb-2" v-if="archiveDetails.bccs" no-gutters>
          <v-col>
            <span>Bcc&nbsp;:&nbsp;</span>
            <span class="description-item">{{
              getEmailList(archiveDetails.bccs)
            }}</span>
          </v-col>
        </v-row>

        <v-row class="ml-3 mb-2" no-gutters>
          <v-col>
            <span>Date : </span>
            <span class="description-item">{{
              getFormatedDateAsPerTimeZone(archiveDetails.sentDate)
            }}</span>
          </v-col></v-row
        >
      </v-col>
    </v-row>
    <v-row no-gutters v-if="Object.keys(attachments).length > 0">
      <v-col sm="12" class="py-0">
        <v-tabs
          slider-color="#58E2C2"
          class="recent_project ml-4"
          show-arrows
          v-model="selectedTab"
          data-test-id="email-tabs"
        >
          <v-tab
            :disabled="pdfLoading"
            :data-test-id="`email-content-tab`"
            @click="setCurrentAttachment(0)"
          >
            Email
          </v-tab>

          <v-tab
            v-for="(attachment, index) in attachments"
            :key="index"
            :disabled="pdfLoading"
            :data-test-id="`email-attachment__${attachment}-tab`"
            @click="setCurrentAttachment(index)"
          >
            {{ attachment }}
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <EmailViewer
      class="pl-3"
      :allUserObj="allUserObj"
      :archiveDetails="archiveDetails"
      :loading="loading"
      :selectedArchiveId="selectedArchiveId"
      v-if="
        Object.keys(attachments).length === 0 ||
          (Object.keys(attachments).length > 0 && selectedTab === 0)
      "
    />
    <RenderAttachment
      class="pl-3"
      v-else
      @setPdfStatus="pdfStatus => (pdfLoading = pdfStatus)"
      :archiveDetails="archiveDetails"
      :attachmentIndex="currentAttachmentIndex"
      :type="'EMAIL'"
    />
  </v-container>
</template>

<script>
import EventBus from '@/EventBus';
// import Button from '@/components/Common/FilledButton';
import SearchService from '@/services/SearchService';
import EmailViewer from './EmailView/EmailViewer';
import RenderAttachment from './AttachmentRender/RenderAttachment';

export default {
  components: { EmailViewer, RenderAttachment },
  props: ['allUserObj'],
  data() {
    return {
      loading: false,
      pdfLoading: false,
      selectedArchiveId: null,
      selectedTags: [],
      displayOnly: false,
      tagContent: null,
      currentAttachmentIndex: 0,
      archiveDetails: null,
      attachments: {},
      selectedTab: 0,
      showDocument: false
    };
  },
  mounted() {
    this.selectedArchiveId = this.$route.params.archiveId;
    this.currentAttachmentIndex = Number(this.$route.params.attachmentId) || 0;
    this.selectedTab = Number(this.$route.params.attachmentId) || 0;
    this.getArchiveDetails();

    EventBus.$on('REFRESH_ARCHIVE_DETAILS', () => {
      this.getArchiveDetails();
    });
  },

  methods: {
    // selects pre selected comments and tags on page
    // get details of the email
    async getArchiveDetails() {
      this.loading = true;
      try {
        let archiveDetails = await SearchService.archiveDetails(
          this.selectedArchiveId,
          this.userInformation?.userId,
          this.$route.params.projectId
        );
        if (!archiveDetails || !(archiveDetails && archiveDetails.data)) {
          this.loading = false;
          return false;
        }
        if (!archiveDetails.data.body.length) {
          this.loading = false;
          return false;
        }
        this.archiveDetails = archiveDetails.data.body[0];
        this.attachments = this.archiveDetails.attachmentNames;

        this.loading = false;

        this.renderDocument();
      } catch (err) {
        this.loading = false;
        let message = '';
        if (err.response && err.response.status === '404') {
          this.initalRoute('GO_TO_INITAL');
        } else if (err.response && err.response.data) {
          message = err.response.data.errors[0].message;
        } else {
          message = err;
        }
        this.snackbar('error', message);
        this.backToProject();
      }
    },
    // go back to saved items route
    goToSavedItems() {
      this.$router.replace(
        `/discovery/projects/${this.$route.params.projectId}/archives/p1`
      );
    },
    // emit event to display tags and comments if any
    renderDocument() {
      if (this.currentAttachmentIndex === 0) {
        this.$nextTick(() => {
          EventBus.$emit('EMAIL_PROCESS_COMMENT_TAG');
        });
      }
    },
    // go back to the previous route
    goback() {
      this.$router.go(-1);
    },
    // back to archives route if having error in loading archive details
    backToProject() {
      this.$router.push({
        path:
          '/discovery/projects/' + this.$route.params.projectId + '/archives'
      });
    },
    /**
     * set to current attachment route
     * @param {Number} index
     */
    setCurrentAttachment(index) {
      if (this.pdfLoading) {
        return this.snackbar('error', 'Previous already in progress');
      }
      if (Number(index) === this.currentAttachmentIndex) {
        return;
      }
      this.currentAttachmentIndex = Number(index);

      this.$router.push({
        path:
          '/discovery/projects/' +
          this.$route.params.projectId +
          '/archive/' +
          encodeURIComponent(this.selectedArchiveId) +
          '/attachment/' +
          this.currentAttachmentIndex
      });
    }
  },
  beforeDestroy() {
    EventBus.$off('REFRESH_ARCHIVE_DETAILS');
  }
};
</script>

<style scoped>
.scale-up-center {
  -webkit-animation: scale-up-center 0.6s cubic-bezier(0.39, 0.575, 0.565, 1)
    infinite both;
  animation: scale-up-center 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) infinite
    both;
}

button.addIcon.scale-up-center {
  background: #58e2c2;
}

button.addIcon.scale-up-center i {
  color: #fff;
}
@keyframes scale-up-center {
  0% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(1);
  }
}

.archive-detail .v-btn {
  border-radius: 0;
}

.archive-detail .comment_desc {
  overflow-wrap: break-word;
}
.stripIndicator {
  width: 100%;
  height: 9px;
  box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
}
.tags,
.discovery_tag_bg {
  background-color: #7440fb;
}
.comment,
.discovery_comment_bg {
  background-color: #58e2c2;
}
.data-tag {
  padding: 40px;
  border: solid 1.5px #bfbfbf;
  overflow-y: hidden;
  height: 100%;
}
.email-data {
  position: relative;
  height: 100vh;
}

.tag_box .v-btn {
  border-radius: 0 !important;
}
.addIcon::before {
  border-radius: 50% !important;
  background-color: #d8d8d8;
  width: 38px;
  height: 38px;
}
.addIcon {
  background-color: #d8d8d8;
  width: 38px !important;
  height: 38px !important;
  border-radius: 50% !important;
}
.data-actions {
  position: absolute;
  top: 50%;
  right: -16px;
}
.addChild {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: calc(100% + 15px);
  top: calc(50% - 38px);
}
.row .col span {
  font-weight: 600;
}
.description-item {
  color: #525252;
  font-size: 14px;
}
</style>
